<footer class="footer">
  <div class="text-center">
    &copy; 2020 <a href="http://www.fmhaca.gov.et" target="_blank">Ethiopian Food and Drug Authority</a>
    (EFDA)
    <span>| eRIS - Version {{version}} - {{environment}} </span>
  </div>
</footer>